module.exports = __webpack_public_path__ + "img/4.a0d3a5b5.jpg";